import type { ReactNode } from 'react';
import './AlertBanner.css';

type AlertVariant = 'info' | 'warning' | 'error' | 'success';

export function AlertBanner({
  variant = 'info',
  title,
  children,
  actions,
  role = 'alert',
  testId,
}: {
  variant?: AlertVariant;
  title: string;
  children?: ReactNode;
  actions?: ReactNode;
  /** `status` for news that can wait (read politely, not at once). */
  role?: 'alert' | 'status';
  testId?: string;
}) {
  return (
    <div
      className={`nx-alert-banner nx-alert-banner--${variant}`}
      role={role}
      data-testid={testId}
    >
      <div className="nx-alert-banner__body">
        <div className="nx-alert-banner__title">{title}</div>
        {children && <div className="nx-alert-banner__detail">{children}</div>}
      </div>
      {actions && <div className="nx-alert-banner__actions">{actions}</div>}
    </div>
  );
}